/**
 * Brand assets — Dino Detective official logo and dinosaur collection.
 * Uploaded by owner.
 */
export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_dino-safety-hub/artifacts/tmnnftjx_dino-logo.png";

export const DINO_TREX_URL =
    "https://customer-assets.emergentagent.com/job_dino-safety-hub/artifacts/t8d6uqgt_Tyrannosaurus%20Rex.png";

export const DINO_BRACHIO_URL =
    "https://customer-assets.emergentagent.com/job_dino-safety-hub/artifacts/0gi1xfn2_Brachiosaurus.png";
